import { formatDuration } from "@/entities/flight";
import { IFlightSegment } from "@/shared/api/aviabooking";
import { FC, Fragment, useState } from "react";

interface FlightSegmentsBarProps {
  segments: Pick<IFlightSegment, 'arr_airport_code' | 'dep_airport_code' | 'flight_time'>[]
}

export const FlightSegmentsBar: FC<FlightSegmentsBarProps> = ({ segments }) => {
  const [hoveredSegment, setHoveredSegment] = useState<number | null>(null);
  const totalFlightTime = segments.reduce((sum, segment) => sum + segment.flight_time, 0);

  return (
    <div className="w-full my-5 text-sm relative">
      <div className="font-normal text-base mb-3 text-slate-500 text-center">
        В пути: {formatDuration(totalFlightTime)}
      </div>

      <div className="relative w-full">
        <div className="flex h-2 rounded-full overflow-visible bg-gray-100 relative">
          {segments.map((segment, index) => (
            <Fragment key={`segment-${index}`}>
              <div
                className={`h-full transition-all duration-200 relative cursor-pointer ${
                  hoveredSegment === index ? 'scale-y-125 z-10 shadow-md' : ''
                } ${index % 2 === 0 ? 'bg-slate-300' : 'bg-slate-200'} ${
                    index === 0 ? 'rounded-l-full': ''
                } ${
                    index === segments.length - 1 ? 'rounded-r-full' : ''
                }`}
                style={{ width: `${(segment.flight_time / totalFlightTime) * 100}%` }}
                onMouseEnter={() => setHoveredSegment(index)}
                onMouseLeave={() => setHoveredSegment(null)}
              >
                {hoveredSegment === index && (
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-gray-800 text-white px-3 py-1 rounded text-xs whitespace-nowrap z-20 min-w-max">
                    {segment.dep_airport_code} → {segment.arr_airport_code}: {formatDuration(segment.flight_time)}
                    <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-r-[5px] border-t-[5px] border-l-transparent border-r-transparent border-t-gray-800"></div>
                  </div>
                )}
              </div>
              {index < segments.length - 1 && (
                <div className="relative">
                  <div className="absolute top-full left-0 -ml-5 mt-1 z-10">
                    <span className="font-semibold text-color-primary whitespace-nowrap px-2 py-0.5 rounded-full text-base">
                      {segment.arr_airport_code}
                    </span>
                  </div>
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
      <div className="flex justify-between mt-1">
        <div className="font-semibold text-color-primary text-base px-1">
          {segments[0].dep_airport_code}
        </div>
        <div className="font-semibold text-color-primary text-base px-1">
          {segments[segments.length - 1].arr_airport_code}
        </div>
      </div>
    </div>
  );
}